import { createApiClient, responseData } from '#lib/api/client.js';
import type { operations } from '#lib/api/generated/schema.js';

export type PrimaryCollectionArtworksParams =
	operations['getPrimaryCollectionArtworks']['parameters']['query'];

// Shared between the universal load (cache seeding, prefetch) and the page
// component's infinite query — the two must hash identically for the seeded
// first page to be found.
export const primaryCollectionArtworksQueryKey = (
	params: PrimaryCollectionArtworksParams
) => ['primary-collection-artworks', params];

export const getPrimaryCollectionPage = async (
	fetchFn: typeof globalThis.fetch | undefined,
	collectionSlug: string
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/primary-collection/{collectionSlug}',
			{ params: { path: { collectionSlug } } }
		)
	);

export const getPrimaryCollectionArtworks = async (
	fetchFn: typeof globalThis.fetch | undefined,
	query: PrimaryCollectionArtworksParams
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/primary-collection-artworks',
			{ params: { query } }
		)
	);

export type PrimaryCollectionPageResponse = Awaited<
	ReturnType<typeof getPrimaryCollectionPage>
>;
export type PrimaryCollectionArtworksResponse = Awaited<
	ReturnType<typeof getPrimaryCollectionArtworks>
>;
export type PrimaryGalleryArtwork =
	PrimaryCollectionArtworksResponse['artworks'][number];
